import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedStoreDTO, WebPushSubscriptionInDTO } from '../type';
import {
  getWebPushSubscriptionThunk,
  subscribeToWebPushNotificationsThunk,
  unsubscribeFromWebPushNotificationsThunk,
  updateWebPushSubscriptionStoresThunk,
} from './webPush.thunk';

interface webPushSubscriptionState {
  subscription: {
    data: WebPushSubscriptionInDTO | null;
    isLoading: boolean;
    hasError: boolean;
  };
  dialog: {
    isOpen: boolean;
    isLoading: boolean;
    hasError: boolean;
  };
}

const initialState: webPushSubscriptionState = {
  subscription: {
    data: null,
    isLoading: false,
    hasError: false,
  },
  dialog: {
    isOpen: false,
    isLoading: false,
    hasError: false,
  },
};

export const { actions, reducer } = createSlice({
  name: 'webPushSubscription',
  initialState,
  reducers: {
    updateSelectedStoresSubscription: (state, action: PayloadAction<SelectedStoreDTO[]>) => {
      if (state.subscription.data) {
        state.subscription.data.selectedStores = action.payload;
      }
    },
    updateTagsInStoreSubscription: (state, action: PayloadAction<{ storeId: string; tagIds: string[] }>) => {
      if (state.subscription.data) {
        const selectedStore = state.subscription.data.selectedStores.find(
          store => store.storeId === action.payload.storeId,
        );
        if (selectedStore) {
          selectedStore.tagIds = action.payload.tagIds;
        }
      }
    },
    setdialog: (state, action) => {
      state.dialog = {
        ...state.dialog,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    builder.addCase(subscribeToWebPushNotificationsThunk.pending, state => {
      state.dialog.isLoading = true;
      state.dialog.hasError = false;
    });
    builder.addCase(subscribeToWebPushNotificationsThunk.fulfilled, (state, action) => {
      state.subscription.data = action.payload;
      state.dialog.isLoading = false;
      state.dialog.hasError = false;
    });
    builder.addCase(subscribeToWebPushNotificationsThunk.rejected, state => {
      state.dialog.isLoading = false;
      state.dialog.hasError = true;
    });
    builder.addCase(getWebPushSubscriptionThunk.pending, state => {
      state.subscription.isLoading = true;
      state.subscription.hasError = false;
    });
    builder.addCase(getWebPushSubscriptionThunk.fulfilled, (state, action) => {
      state.subscription.data = action.payload;
      state.subscription.isLoading = false;
      state.subscription.hasError = false;
    });
    builder.addCase(getWebPushSubscriptionThunk.rejected, state => {
      state.subscription.isLoading = false;
      state.subscription.hasError = true;
    });
    builder.addCase(unsubscribeFromWebPushNotificationsThunk.pending, state => {
      state.subscription.isLoading = true;
      state.subscription.hasError = false;
    });
    builder.addCase(unsubscribeFromWebPushNotificationsThunk.fulfilled, state => {
      state.subscription.data = null;
      state.subscription.isLoading = false;
      state.subscription.hasError = false;
      state.dialog.isOpen = false;
    });
    builder.addCase(unsubscribeFromWebPushNotificationsThunk.rejected, state => {
      state.subscription.isLoading = false;
      state.subscription.hasError = true;
    });
    builder.addCase(updateWebPushSubscriptionStoresThunk.pending, state => {
      state.dialog.isLoading = true;
      state.dialog.hasError = false;
    });
    builder.addCase(updateWebPushSubscriptionStoresThunk.fulfilled, (state, action) => {
      if (state.subscription.data) {
        state.subscription.data.selectedStores = action.payload.selectedStores;
      }
      state.dialog.isLoading = false;
      state.dialog.hasError = false;
      state.dialog.isOpen = false;
    });
    builder.addCase(updateWebPushSubscriptionStoresThunk.rejected, state => {
      state.dialog.isLoading = false;
      state.dialog.hasError = true;
    });
  },
});

export const {
  updateSelectedStoresSubscription: updateWebPushSubscriptionStores,
  updateTagsInStoreSubscription: updateWebPushSubscriptionTags,
  setdialog: setNotificationWebPushDialog,
} = actions;
